const {GroupDataConfiguration} = require("./configuration/group-data-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const GroupDataStepTabs = {
    configuration: GroupDataConfiguration,
    preview: PreviewTab,
};
exports.GroupDataStepTabs = GroupDataStepTabs;
